import React from "react";
import {
  Box,
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";

interface GroupBySectionProps {
  groupBy: "variable" | "value";
  isDisabled: boolean;
  onGroupByChange: (value: "variable" | "value") => void;
}

/**
 * Required "Group By" control at the top of the grouped bar editor. Choosing the
 * dimension swaps which grid dimension forms the groups (x-axis clusters) vs the
 * series (legend). Maps to focusMode (VARIABLE | VALUE) on the request.
 */
const GroupBySection: React.FC<GroupBySectionProps> = ({
  groupBy,
  isDisabled,
  onGroupByChange,
}) => {
  return (
    <>
      <Box sx={{ p: 2, border: "1px solid #e0e0e0", borderRadius: 1 }}>
        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
          Group By*
        </Typography>

        <RadioGroup
          value={groupBy}
          onChange={(e) =>
            onGroupByChange(e.target.value as "variable" | "value")
          }
        >
          <FormControlLabel
            value="variable"
            control={<Radio size="small" />}
            label="Variables (variables are groups, values are series)"
            disabled={isDisabled}
          />
          <FormControlLabel
            value="value"
            control={<Radio size="small" />}
            label="Values (values are groups, variables are series)"
            disabled={isDisabled}
          />
        </RadioGroup>
      </Box>

      <Divider />
    </>
  );
};

export default GroupBySection;
